import { z } from "zod";

import { i18n } from "@libs/i18n";
import {
  insertVehiclesTypeSchema,
  publicVehicleStatusEnumSchema,
  requiredStringSchema,
  rowVehiclesTypeSchema,
  rowVehicleTypesTypeSchema,
  updateVehiclesTypeSchema,
} from "@libs/schemas";

export const vehicleSchema = rowVehiclesTypeSchema.merge(
  z.object({
    vehicle_type: rowVehicleTypesTypeSchema
      .pick({
        id: true,
        type_name: true,
      })
      .optional(),
  }),
);

export type VehicleType = z.infer<typeof vehicleSchema>;

export const vehicleFormSchema = insertVehiclesTypeSchema
  .pick({ name: true, plate: true, vehicle_type_id: true })
  .extend({
    name: requiredStringSchema,
    plate: requiredStringSchema,
    vehicle_type_id: z.string().uuid(i18n.t("common:validation.requiredField")),
  });
export type VehicleFormType = z.infer<typeof vehicleFormSchema>;

export type VehicleCreateType = z.infer<typeof vehicleFormSchema>;
export type VehicleUpdateType = Omit<
  z.infer<typeof updateVehiclesTypeSchema>,
  "created_at" | "updated_at"
>;

export type VehicleStatusType = z.infer<typeof publicVehicleStatusEnumSchema>;
export const VehicleStatusEnum = publicVehicleStatusEnumSchema.enum;

export type VehiclePlateCheckParamsType = {
  plate: string;
  excludeVehicleId?: string;
};

export type VehicleNameCheckParamsType = {
  name: string;
  excludeVehicleId?: string;
};

export const vehicleFilterSchema = z.object({
  search: z.string().optional().catch(""),
  vehicleTypeIds: z.array(z.string()).optional().catch([]),
  statuses: z.array(publicVehicleStatusEnumSchema).optional().catch([]),
});
export type VehicleFilterType = z.infer<typeof vehicleFilterSchema>;

export const vehicleSearchParamsSchema = vehicleFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export const vehicleStatusOptions = publicVehicleStatusEnumSchema.options.map(
  status => ({
    value: status,
    label:
      status === VehicleStatusEnum.ACTIVE
        ? i18n.t("common:active")
        : i18n.t("common:inactive"),
  }),
);
